export enum EFieldOptionsType {
  Modules = 'modules',
  Paths = 'paths',
  CustomQuestionnaire = 'customQuestionnaire',
  NpsSurvey = 'npsSurvey'
}
